<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col cols="12" md="12">
                <component-header
                    title="View Coupon"
                    :hasSearch="false"
                    :hasCreate="false"
                    :hasReload="false"
                    :hasback="true"
                    @back-press="$router.push('/setup/Coupon')"
                />
            </b-col>
        </b-row>
        <b-row class="mt-2" v-if="Object.keys(details).length">
            <b-col cols="12" md="12">
                <b-card>
                    <b-row>
                        <b-col cols="12" sm="12" md="4">
                            <div class="form-group">
                                <label for="promoCode">Coupon Code</label>
                                <b-form-input
                                    id="promoCode"
                                    disabled
                                    inputType="text"
                                    v-model="details.promoCode"
                                />
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div class="form-group">
                                <label for="categoryOptions"
                                    >Applicable On</label
                                >
                                <b-form-input
                                    id="categoryOptions"
                                    type="text"
                                    disabled
                                    label="label"
                                    v-model="details.promoRules.applicableOn"
                                ></b-form-input>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div class="form-group">
                                <label for="title">Title</label><br />
                                <b-form-input
                                    id="title"
                                    type="text"
                                    disabled
                                    label="label"
                                    v-model="details.title"
                                ></b-form-input>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div class="form-group">
                                <label for="description">Description</label
                                ><br />
                                <b-form-input
                                    id="description"
                                    type="text"
                                    disabled
                                    label="label"
                                    v-model="details.description"
                                ></b-form-input>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div class="form-group">
                                <label for="startdate">Start Date</label>
                                <b-input
                                    id="startdate"
                                    disabled
                                    type="text"
                                    :value="formattedStartDate"
                                ></b-input>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div class="form-group">
                                <label for="enddate">End Date</label>
                                <b-input
                                    id="enddate"
                                    disabled
                                    type="text"
                                    :value="formattedEndDate"
                                ></b-input>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div class="form-group">
                                <label for="maxRewardValue"
                                    >Max Reward Value</label
                                >
                                <b-form-input
                                    id="maxRewardValue"
                                    inputType="text"
                                    :disabled="true"
                                    maxlength="100"
                                    v-model="details.promoRules.maxRewardValue"
                                />
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div class="form-group">
                                <label for="minimumAmountExcludingTax"
                                    >MinimumAmount Excluding Tax</label
                                >
                                <b-form-input
                                    id="minimumAmountExcludingTax"
                                    inputType="text"
                                    disabled
                                    maxlength="100"
                                    v-model="
                                        details.promoRules
                                            .minimumAmountExcludingTax
                                    "
                                />
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div class="form-group">
                                <label for="discountType">Discount Type</label>
                                <b-form-input
                                    id="discountType"
                                    type="text"
                                    disabled
                                    label="label"
                                    v-model="details.promoRules.discountType"
                                ></b-form-input>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div class="form-group">
                                <label for="rewardValue">Reward Value</label>

                                <b-input
                                    id="rewardValue"
                                    disabled
                                    type="text"
                                    v-model="details.promoRules.rewardValue"
                                ></b-input>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div class="form-group">
                                <label for="rewardType">Reward Type</label>
                                <b-form-input
                                    id="rewardType"
                                    disabled
                                    type="text"
                                    label="label"
                                    v-model="details.promoRules.rewardType"
                                ></b-form-input>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div class="form-group">
                                <label for="within">Frequency in minutes</label>
                                <b-form-input
                                    id="within"
                                    disabled
                                    inputType="text"
                                    v-model="details.timingRules.within"
                                />
                            </div>
                        </b-col>

                        <b-col md="4">
                            <label for="totalLimit">Total allowed in day</label>
                            <b-form-input
                                id="totalLimit"
                                disabled
                                inputType="text"
                                v-model="details.timingRules.totalLimit"
                            />
                        </b-col>
                        <b-col md="4" class="pr-0">
                            <label for="tc">Terms And Conditions</label><br />
                            <b-form-input
                                id="tc"
                                disabled
                                inputType="text"
                                v-model="details.tc"
                            />
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import ComponentHeader from "@/components/componentNewHeader";

const formatDate = (dateValue) => {
    if (!dateValue) {
        return "";
    }

    const date = new Date(dateValue);
    return date.toLocaleDateString();
};

export default {
    name: "ViewCoupon",
    components: {
        ComponentHeader,
    },
    data() {
        return {
            details: {},
        };
    },
    computed: {
        userRole() {
            return (
                this.$store.getters["auth/getUserRole"] ||
                JSON.parse(sessionStorage.getItem("userLogin"))["role"]
            );
        },
        formattedStartDate() {
            const startDate = this.details.promoRules
                ? this.details.promoRules.startDate
                : "";
            return formatDate(startDate);
        },
        formattedEndDate() {
            const endDate = this.details.promoRules
                ? this.details.promoRules.endDate
                : "";
            return formatDate(endDate);
        },
    },
    mounted() {
        this.details = { ...this.$route.params.data };
    },
};
</script>
<style scoped>
</style>
